<template>
    <div
        class="border rounded-md flex flex-col items-center bg-light-grey p-4 pt-6"
        :class="{ 'border-black': isProductSelected }"
    >
        <ProductImage
            :product-media="registrationProduct?.cover?.media ?? {}"
            src-set-until="800"
            main-class="cover"
            loading="lazy"
        ></ProductImage>
        <p class="text-center">
            {{ registrationProduct.translated?.name ?? registrationProduct?.translated?.metaTitle ?? '' }}
        </p>
    </div>
</template>

<script setup>
import ProductImage from '~/templates/elements/ProductImage.vue';

defineProps(['registrationProduct', 'isProductSelected']);
</script>
